"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = props => {
  return _react.default.createElement(_SvgIcon.default, null, _react.default.createElement("path", {
    d: "M9 12C9 13.6569 10.3431 15 12 15V15C13.6569 15 15 13.6569 15 12V12C15 10.3431 13.6569 9 12 9V9C10.3431 9 9 10.3431 9 12V12Z",
    fill: "black"
  }), _react.default.createElement("path", {
    d: "M20 21L20 19L4 19L4 21L20 21Z",
    fill: "black"
  }), _react.default.createElement("rect", {
    x: "4",
    y: "3",
    width: "16",
    height: "2",
    fill: "black"
  }));
};

exports.default = _default;
module.exports = exports.default;